import React from 'react';
import PropTypes from 'prop-types';
import PictionJS from 'piction-js';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import MetadataViewMetaGroup from './MetadataViewGroup';
import MetadataViewItem from './MetadataViewItem';
import { DEFAULT_COLLECTION_ID } from '../../constants/session';

const mapStateToProps = (state) => ({
  session: state.session,
});

function MetadataView({ umo, toggleUMODetailView, dispatch, intl, session }) {
  const groupedMetadata = new Map();

  umo.metadataList.all.forEach((metadata) => {
    if (groupedMetadata.has(metadata.id)) {
      groupedMetadata.get(metadata.id).push(metadata);
    } else {
      groupedMetadata.set(metadata.id, [metadata]);
    }
  });

  const metaItems = [];
  for (const [key, value] of groupedMetadata) {
    if (_.isArray(value)) {
      value.forEach((metadata, i) =>
        metaItems.push(
          <MetadataViewItem
            key={`${metadata.id}${i > 0 && `_${i}`}`}
            metadata={metadata}
            showValueOnly={i > 0}
            parseList={session.get('parsedMetatags')}
            keywordDelim={session.get('keywordDelimiter')}
            dispatch={dispatch}
            toggleUMODetailView={toggleUMODetailView}
          />
        )
      );
    }
  }

  return metaItems.length > 0 ? (
    <MetadataViewMetaGroup
      metaItems={metaItems}
      umoID={umo.id}
      toggleUMODetailView={toggleUMODetailView}
      umo={umo}
    />
  ) : (
    <p>
      <br /> <br />
      {intl.formatMessage({ id: 'metadataView.noMetadata' })}
    </p>
  );
}

MetadataView.propTypes = {
  toggleUMODetailView: PropTypes.func,
  umo: PropTypes.instanceOf(PictionJS.UMO),
  dispatch: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, null)(MetadataView));
